module.exports = __webpack_public_path__ + "img/detail_icon_lawyer82.5eb354be.png";